// TODO: REFACTORING
import React from 'react';
import * as Styled from './ButtonShowMore.style';

const ButtonShowMore = ({ label }) => {
  return <Styled.Button>{label}</Styled.Button>;
};

export default ButtonShowMore;
